<template>
  <div>
    <div class="app-bar row pt-0 ml-0 align-items-center">
      <div class="col">
        <button class="menu-button p-0" v-if="goBackAllowed" @click="goBack">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button class="menu-button p-0" v-else @click="showBurgerMenu">
          <i class="fas fa-bars"></i>
        </button>
      </div>
      <div class="col">
        <Logo class="position-logo" :showBeta="this.$store.state.isBeta" />
      </div>
      <div class="col text-right">
        <button class="menu-button p-0" @click="showSettingsMenu">
          <i class="fas fa-cog"></i>
        </button>
      </div>
    </div>
    <RefreshNotice />
    <ConnectivityNotice />
    <AppUpdateNotice />
    <BurgerMenu @closeMenu="hideBurgerMenu"/>
    <SettingsMenu @closeMenu="hideSettingsMenu"/>
  </div>
</template>
<script>
import Logo from './Logo.vue'
import BurgerMenu from './BurgerMenu.vue'
import SettingsMenu from './SettingsMenu.vue'
import AppUpdateNotice from './AppUpdateNotice.vue'
import ConnectivityNotice from './ConnectivityNotice.vue'
import RefreshNotice from './RefreshNotice.vue'
import { mapState } from 'vuex'
import { spinnakerApi } from '../js/SpinnakerApi.js'

export default {
  components: {
    Logo,
    BurgerMenu,
    SettingsMenu,
    AppUpdateNotice,
    ConnectivityNotice,
    RefreshNotice
  },
  computed: mapState({
    goBackAllowed: state => state.navigation.goBackAllowed
  }),
  methods: {
    showBurgerMenu () {
      this.$modal.show('burger-menu-modal')
    },
    hideBurgerMenu () {
      this.$modal.hide('burger-menu-modal')
    },
    showSettingsMenu () {
      this.$modal.show('settings-menu-modal')
    },
    hideSettingsMenu () {
      this.$modal.hide('settings-menu-modal')
    },
    isProd () {
      return spinnakerApi.isProd()
    },
    goBack () {
      this.$store.commit('navigation/goBack')
    }
  }
}
</script>
